export default __webpack_public_path__ + "static/media/gallery_13.4387d2d6.jpg";